export default __webpack_public_path__ + "static/media/1200px-Twitter_bird_logo_2012.def7d13d.png";